import { Box, TextField, Typography } from '@mui/material';
import { ChangeEvent, KeyboardEvent, RefObject } from 'react';

interface PincodeProps {
  name?: string;
  size?: 'small' | 'medium';
  error?: boolean;
  placeholder?: string;
  disable?: boolean;
  required?: boolean;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  maxLength?: number;
  inputRef?: RefObject<HTMLInputElement>;
  errormsg?: string;
}

const Pincode = ({ 
  name, 
  size, 
  error, 
  placeholder, 
  disable, 
  required, 
  value, 
  onChange, 
  onKeyDown, 
  maxLength, 
  inputRef, 
  errormsg 
}: PincodeProps) => {
  return (
    <Box>
      <TextField
        error={error}
        name={name}
        label={placeholder}
        variant="outlined"
        disabled={disable}
        size={size}
        fullWidth
        required={required}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        inputProps={{
          maxLength: maxLength,
        }}
        sx={
          required === true ? {
            '.MuiFormLabel-asterisk': {
              color: 'danger.main',
              fontSize: '20px',
              fontWeight: 'bold',
            },
          } : undefined
        }
        inputRef={inputRef}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
        }}
      >
        {errormsg ? errormsg : ''}
      </Typography>
    </Box>
  );
};

export default Pincode;
